import { Route, NavigationGuardNext } from "vue-router";
import { getModule } from "vuex-module-decorators";
import TitleListState from "@/modules/title-list";

export const TotalReportRouteResolver = async function (to: Route, from: Route, next: NavigationGuardNext) {
	const titleListModule = getModule(TitleListState);
	const actions: Promise<void>[] = [];
	if (!titleListModule.levels.length) {
		actions.push(titleListModule.fetchVcsLevels());
	}
	if (!titleListModule.languageSkills.length) {
		actions.push(titleListModule.fetchLanguageSkills());
	}
	if (!titleListModule) await Promise.all(actions);
	next();
};
